import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const ChipItemContainer = styled(BaseFlex)`
    margin: 4px 7px 4px 0px;
    padding: 0;
    text-align: center;
    position: relative;
    background-color: ${colorsPalettes.carbon[50]};
    border-radius: 40px;
    height: 32px;

    .chip-item-icon {
        margin-left: 12px;
    }
`;

export const TextContainer = styled(BaseFlex)`
    margin: 0px 8px 0 12px;
`;

export const ChipItemName = styled.span`
    max-width: 350px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
`;

export const ChipItemViewer = styled.span`
    margin-left: 4px;
    ${setFontVariant("body2", colorsPalettes.carbon[250])}
`;

export const IconCloseContainer = styled.div`
    cursor: pointer;
    margin-right: 5px;

    .SWReactIcons {
        svg {
          path {
            transition: fill-opacity 0.4s ease-out;
          }
          &:hover {
            path {
              fill-opacity: 0.6;
            }
          }
        }
    }
`;
